"use client"
import { createAuthClient } from "better-auth/react"
import { adminClient } from "better-auth/client/plugins"
import { passkeyClient } from "@better-auth/passkey/client"
import { publicEnv } from "@zentjes/config/public-env"

export const authClient = createAuthClient({
  baseURL: typeof window !== "undefined" ? window.location.origin : publicEnv.NEXT_PUBLIC_APP_URL,
  plugins: [adminClient(), passkeyClient()],
})

export const {
  signIn,
  signOut,
  useSession,
  linkSocial,
  unlinkAccount,
  deleteUser,
  listAccounts
} = authClient
